exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".s9LL3joBttcVijKwxgsSz{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
exports.locals = {
	"moveToFocusedOtherMenuItems": "s9LL3joBttcVijKwxgsSz"
};